import { AdminMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenu";
import { AssignmentsLink } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AssignmentsLink/AssignmentsLink";
import { ContentLibraryMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ContentLibraryMenu/ContentLibraryMenu";
import { ReportsMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenu";
import {
  resourceItemsContainerCss,
  resourceItemsVisibilityBreakpointsCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ResourceMenus.styles";
import useUser from "@/users/useUser";
import { useNavBarItemVisibility } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useNavBarItemsVisibilityControl";

const ResourceMenus = () => {
  const { data: user } = useUser();
  const { isVisible } = useNavBarItemVisibility();

  if (!user?.is_authenticated) return null;

  return (
    <li
      css={resourceItemsVisibilityBreakpointsCss(isVisible("resources-menu"))}
    >
      <ul css={resourceItemsContainerCss}>
        <ContentLibraryMenu />
        <ReportsMenu user={user} />
        <AssignmentsLink />
        <AdminMenu />
      </ul>
    </li>
  );
};

ResourceMenus.displayName = "OtherMenuItems";
export { ResourceMenus };
